import { LiquidityState } from './useRemoveLiquidity'

export function getButtonState(state: LiquidityState) {
  switch (state) {
    case LiquidityState.EMPTY:
      return { text: 'No liquidity tokens', error: true, disabled: true }
    case LiquidityState.INSUFFICIENT_LIQUIDITY_IN_PAIR:
      return { text: 'Insufficient liquidity in pair', error: true, disabled: true }
    case LiquidityState.INSUFFICIENT_LIQUIDITY:
      return { text: 'Insufficient liquidity', error: true, disabled: true }
    case LiquidityState.PAIR_DOES_NOT_EXIST:
      return { text: 'Pair does not exist', error: true, disabled: true }
    case LiquidityState.MISSING_INPUT:
    case LiquidityState.LOADING:
    case LiquidityState.NEED_APPROVAL:
      return { text: 'Withdraw', error: false, disabled: true }
    default:
      return { text: 'Withdraw', error: false, disabled: false }
  }
}
